export function isUndefinedOrNullOrEmptyString(
  value: any,
): value is undefined | null | string {
  return value === null || value === undefined || value === "";
}
